export function modifyTopNoteStyleForChatBot() {
  const topNoteElem: HTMLElement | null = document.querySelector(".topNote");
  if (topNoteElem) {
    topNoteElem.style.bottom = "100px";
  }
}

export function getChatBotElement(): HTMLElement | null {
  return document.querySelector(".slaask-button.slaask-component");
}
